import { render, staticRenderFns } from "./ShareToClientModal.vue?vue&type=template&id=4b257b1b&scoped=true&"
import script from "./ShareToClientModal.vue?vue&type=script&lang=js&"
export * from "./ShareToClientModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareToClientModal.vue?vue&type=style&index=0&id=4b257b1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b257b1b",
  null
  
)

export default component.exports